<template>
  <fragment>
    <div class="lojas-perfis-add-edit-container03">
      <h1 class="lojas-perfis-add-edit-text">Lojas / Usuários / Perfis</h1>
    </div>
    <div class="lojas-perfis-add-edit-container04">
      <div class="lojas-perfis-add-edit-container05">
        <div class="lojas-perfis-add-edit-container06">
          <div class="lojas-perfis-add-edit-container07">
            <h1 class="lojas-perfis-add-edit-text01">
              <span>Perfis / Cadastrar - Editar</span>
            </h1>
          </div>
        </div>
      </div>
      <div class="lojas-perfis-add-edit-container08">
        <div class="lojas-perfis-add-edit-container09">
          <label class="lojas-perfis-add-edit-text03 input-labels">
            Descrição do perfil
          </label>
          <v-text-field
            solo
            placeholder="Ex: Admin"
            v-model="$loja_perfis.cadastro.descricao"
            type="text"
            class="lojas-perfis-add-edit-textinput"
          ></v-text-field>
        </div>
        <div class="lojas-perfis-add-edit-container10">
          <label class="lojas-perfis-add-edit-text04 input-labels">
            Ativo
          </label>
          <v-select
            height="48"
            :items="status"
            dense
            solo
            class="lojas-perfis-add-edit-textinput1"
            v-model="$loja_perfis.cadastro.ativo"
            placeholder="ATIVO"
          ></v-select>
        </div>
      </div>
      <div class="lojas-perfis-add-edit-container12">
        <div class="lojas-perfis-add-edit-container13">
          <div class="lojas-perfis-add-edit-container14">
            <h1 class="lojas-perfis-add-edit-text08">Módulos</h1>
            <div class="lojas-perfis-add-edit-container15">
              <div class="lojas-perfis-add-edit-container16">
                <div class="lojas-perfis-add-edit-container17">
                  <span>Adicionar</span>
                </div>
                <div class="lojas-perfis-add-edit-container18">
                  <span>Remover</span>
                </div>
              </div>
              <div class="lojas-perfis-add-edit-container19">
                <div class="lojas-perfis-add-edit-container20">
                  <div
                    class="lojas-perfis-add-edit-container21"
                    v-for="(modulo, index) in addModules"
                    :key="index"
                    @click="setModulo(addModules, modulo, removeModules, 'add')"
                  >
                    <span>{{ modulo.value }}</span>
                    <svg
                      viewBox="0 0 1024 1024"
                      class="lojas-perfis-add-edit-icon"
                    >
                      <path
                        d="M366 708l196-196-196-196 60-60 256 256-256 256z"
                      ></path>
                    </svg>
                  </div>
                </div>
                <div class="lojas-perfis-add-edit-container26">
                  <div
                    class="lojas-perfis-add-edit-container27"
                    v-for="(pm, index) in removeModules"
                    :key="index"
                    @click="setModulo(removeModules, pm, addModules, 'remove')"
                  >
                    <span>{{ pm.value }}</span>
                    <svg
                      viewBox="0 0 1024 1024"
                      class="lojas-perfis-add-edit-icon10"
                    >
                      <path
                        d="M658 708l-60 60-256-256 256-256 60 60-196 196z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="lojas-perfis-add-edit-container29">
        <div class="lojas-perfis-add-edit-container30">
          <v-btn
            height="45"
            class="lojas-perfis-add-edit-button1 button button-bg"
            :loading="$lojas_usuarios.cadastro.loading"
            @click="$loja_perfis.validarCadastro(removeModules)"
          >
            <span class="lojas-perfis-add-edit-text21 button-bg">Salvar</span>
          </v-btn>
        </div>
        <div class="lojas-perfis-add-edit-container31">
          <v-btn
            height="45"
            class="lojas-perfis-add-edit-button2 button button-bg"
            @click="$axios.rota('lojas-perfis')"
          >
            <span class="lojas-perfis-add-edit-text24 button-bg">Cancelar</span>
          </v-btn>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  name: "PerfisSettings",
  metaInfo: {
    title: "Lojas/Perfís | Adicionar/Editar | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Lojas/Perfís | Adicionar/Editar | ElevenTickets",
      },
    ],
  },
  props: {},
  data() {
    return {
      status: [
        { text: "SIM", value: 1 },
        { text: "NÃO", value: 0 },
      ],
      addModules: [],
      removeModules: [],
    };
  },
  methods: {
    setModulo(array, profile, newArray) {
      var profileIndex = array.indexOf(profile);
      if (profileIndex > -1) {
        array.splice(profileIndex, 1);
      }

      newArray.push(profile);
    },
  },
  mounted() {
    if (!this.$axios.getLocal("lojas_modules")) {
      this.$loja_perfis.getModulos();
    }
    this.addModules = this.$axios.getLocal("lojas_modules").data;
  },
};
</script>

<style scoped>
.lojas-perfis-add-edit-container {
  width: 100%;
  display: flex;
  overflow: auto;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}

.lojas-perfis-add-edit-container01 {
  top: 0px;
  left: 0px;
  right: 0px;
  width: 100%;
  bottom: 0px;
  height: 100%;
  margin: auto;
  display: flex;
  position: absolute;
  align-items: flex-end;
  flex-direction: column;
  justify-content: flex-start;
}

.lojas-perfis-add-edit-container02 {
  right: 0px;
  width: 100%;
  bottom: 0px;
  height: calc(100% - 80px);
  position: absolute;
  max-height: 1000px;
}

.lojas-perfis-add-edit-main-perfil {
  right: 0px;
  width: calc(100% - 90px);
  bottom: 0px;
  height: 100%;
  margin: auto;
  display: flex;
  position: absolute;
  max-width: 3000px;
  min-width: 500px;
  align-self: flex-end;
  overflow-x: hidden;
  overflow-y: auto;
  align-items: flex-start;
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 15px;
  flex-direction: column;
  padding-bottom: 15px;
  justify-content: center;
  background-color: #eaeaea;
}

.lojas-perfis-add-edit-body-perfil {
  width: 100%;
  height: 100%;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 15px;
  padding-left: 15px;
  border-radius: 20px;
  padding-right: 15px;
  flex-direction: column;
  padding-bottom: 15px;
  background-color: var(--dl-color-gray-white);
}

.lojas-perfis-add-edit-container03 {
  width: 100%;
  height: 50px;
  display: flex;
  margin-top: 0px;
  align-items: flex-start;
  margin-bottom: 20px;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-add-edit-text {
  font-size: 1.2em;
}

.lojas-perfis-add-edit-container04 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  position: relative;
  align-items: flex-start;
  padding-top: 15px;
  padding-left: 15px;
  border-radius: 20px;
  padding-right: 15px;
  flex-direction: column;
  padding-bottom: 15px;
  justify-content: flex-start;
  background-color: #eaeaea;
}

.lojas-perfis-add-edit-container05 {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  flex-direction: column;
}

.lojas-perfis-add-edit-container06 {
  flex: 0 0 auto;
  width: 100%;
  height: 60px;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}

.lojas-perfis-add-edit-container07 {
  top: 0px;
  flex: 0 0 auto;
  left: 0px;
  width: 200px;
  height: 100%;
  display: flex;
  position: absolute;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-add-edit-text01 {
  width: 366px;
  font-size: 1em;
  align-self: flex-start;
}

.lojas-perfis-add-edit-container08 {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-direction: row;
  justify-content: flex-start;
}

.lojas-perfis-add-edit-container09 {
  flex: 0 0 auto;
  width: 50%;
  height: 100px;
  display: flex;
  align-items: flex-start;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-add-edit-text03 {
  margin-bottom: 6px;
}

.lojas-perfis-add-edit-textinput {
  width: 100%;
  height: 51px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.lojas-perfis-add-edit-container10 {
  flex: 0 0 auto;
  width: 50%;
  height: auto;
  display: flex;
  align-items: space-between;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 6px;
  flex-direction: column;
}

.lojas-perfis-add-edit-text04 {
  margin-bottom: 6px;
}

.lojas-perfis-add-edit-textinput1 {
  width: 100%;
  height: 51px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.lojas-perfis-add-edit-container11 {
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: 5px;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-add-edit-button {
  color: var(--dl-color-gray-white);
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-add-edit-text05 {
  font-size: 20px;
}

.lojas-perfis-add-edit-container12 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
}

.lojas-perfis-add-edit-container13 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
}

.lojas-perfis-add-edit-container14 {
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
  padding-bottom: 5px;
  justify-content: center;
}

.lojas-perfis-add-edit-text08 {
  font-size: 1em;
  margin-bottom: 10px;
}

.lojas-perfis-add-edit-container15 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  border-radius: 20px;
  flex-direction: column;
  background-color: #d9d9d9;
}

.lojas-perfis-add-edit-container16 {
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  padding-top: 5px;
  border-color: rgba(120, 120, 120, 0.4);
  border-width: 1px;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: row;
  padding-bottom: 5px;
  justify-content: center;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 0px;
}

.lojas-perfis-add-edit-container17 {
  flex: 0 0 auto;
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-add-edit-container18 {
  flex: 0 0 auto;
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-add-edit-container19 {
  width: 100%;
  height: 95%;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: flex-start;
}

.lojas-perfis-add-edit-container20 {
  flex: 0 0 auto;
  width: 50%;
  height: 100%;
  display: flex;
  padding: 20px;
  align-items: center;
  padding-top: 5px;
  border-color: rgba(120, 120, 120, 0.4);
  border-width: 2px;
  padding-left: 5px;
  padding-right: 5px;
  flex-direction: column;
  padding-bottom: 5px;
  justify-content: center;
  border-top-width: 0px;
  border-left-width: 0px;
  border-right-width: 1px;
  border-bottom-width: 0px;
}

.lojas-perfis-add-edit-container21 {
  width: 100%;
  height: 40px;
  display: flex;
  position: relative;
  align-items: center;
  border-color: var(--dl-color-gray-black);
  border-width: 0px;
  padding-left: 20px;
  border-radius: var(--dl-radius-radius-radius4);
  margin-bottom: 5px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #c9c9c9;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.lojas-perfis-add-edit-container21:hover {
  color: var(--dl-color-gray-white);
  fill: var(--dl-color-gray-white);
  cursor: pointer;
}

.lojas-perfis-add-edit-icon {
  top: 5px;
  right: 0px;
  width: 30px;
  height: 30px;
  position: absolute;
  transition: 0.3s;
}

.lojas-perfis-add-edit-container22 {
  width: 100%;
  height: 40px;
  display: flex;
  position: relative;
  align-items: center;
  border-color: var(--dl-color-gray-black);
  border-width: 0px;
  padding-left: 20px;
  border-radius: var(--dl-radius-radius-radius4);
  margin-bottom: 5px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #c9c9c9;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.lojas-perfis-add-edit-icon02 {
  top: 5px;
  right: 0px;
  width: 30px;
  height: 30px;
  position: absolute;
  transition: 0.3s;
}

.lojas-perfis-add-edit-container23 {
  width: 100%;
  height: 40px;
  display: flex;
  position: relative;
  align-items: center;
  border-color: var(--dl-color-gray-black);
  border-width: 0px;
  padding-left: 20px;
  border-radius: var(--dl-radius-radius-radius4);
  margin-bottom: 5px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #c9c9c9;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.lojas-perfis-add-edit-icon04 {
  top: 5px;
  right: 0px;
  width: 30px;
  height: 30px;
  position: absolute;
  transition: 0.3s;
}

.lojas-perfis-add-edit-container24 {
  width: 100%;
  height: 40px;
  display: flex;
  position: relative;
  align-items: center;
  border-color: var(--dl-color-gray-black);
  border-width: 0px;
  padding-left: 20px;
  border-radius: var(--dl-radius-radius-radius4);
  margin-bottom: 5px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #c9c9c9;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.lojas-perfis-add-edit-icon06 {
  top: 5px;
  right: 0px;
  width: 30px;
  height: 30px;
  position: absolute;
  transition: 0.3s;
}

.lojas-perfis-add-edit-container25 {
  width: 100%;
  height: 40px;
  display: flex;
  position: relative;
  align-items: center;
  border-color: var(--dl-color-gray-black);
  border-width: 0px;
  padding-left: 20px;
  border-radius: var(--dl-radius-radius-radius4);
  margin-bottom: 5px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: flex-start;
  background-color: #c9c9c9;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.lojas-perfis-add-edit-icon08 {
  top: 5px;
  right: 0px;
  width: 30px;
  height: 30px;
  position: absolute;
  transition: 0.3s;
}

.lojas-perfis-add-edit-container26 {
  flex: 0 0 auto;
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  flex-direction: column;
  padding-bottom: 20px;
  justify-content: center;
}

.lojas-perfis-add-edit-container27 {
  width: 100%;
  height: 40px;
  display: flex;
  position: relative;
  align-items: center;
  border-color: var(--dl-color-gray-black);
  border-width: 0px;
  padding-left: 20px;
  border-radius: var(--dl-radius-radius-radius4);
  margin-bottom: 5px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: flex-end;
  background-color: #c9c9c9;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.lojas-perfis-add-edit-container27:hover {
  color: var(--dl-color-gray-white);
  fill: var(--dl-color-gray-white);
  cursor: pointer;
}

.lojas-perfis-add-edit-icon10 {
  top: 8px;
  left: 0px;
  width: 30px;
  height: 30px;
  position: absolute;
}

.lojas-perfis-add-edit-container28 {
  width: 100%;
  height: 40px;
  display: flex;
  position: relative;
  align-items: center;
  border-color: var(--dl-color-gray-black);
  border-width: 0px;
  padding-left: 20px;
  border-radius: var(--dl-radius-radius-radius4);
  margin-bottom: 5px;
  padding-right: 20px;
  flex-direction: row;
  justify-content: flex-end;
  background-color: #c9c9c9;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.lojas-perfis-add-edit-icon12 {
  top: 8px;
  left: 0px;
  width: 30px;
  height: 30px;
  position: absolute;
}

.lojas-perfis-add-edit-container29 {
  flex: 0 0 auto;
  width: 100%;
  height: 70px;
  display: flex;
  position: relative;
  align-items: center;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  flex-direction: row;
  padding-bottom: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

.lojas-perfis-add-edit-container30 {
  flex: 0 0 auto;
  width: 130px;
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 20px;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-add-edit-button1 {
  color: var(--dl-color-gray-white);
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-add-edit-text21 {
  font-size: 20px;
}

.lojas-perfis-add-edit-container31 {
  flex: 0 0 auto;
  width: 130px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.lojas-perfis-add-edit-button2 {
  color: var(--dl-color-gray-white);
  width: 100%;
  height: 51px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.lojas-perfis-add-edit-text24 {
  font-size: 20px;
}

@media (max-width: 991px) {
  .lojas-perfis-add-edit-main-perfil {
    width: 100%;
    margin: auto;
    min-width: 320px;
  }
}

@media (max-width: 767px) {
  .lojas-perfis-add-edit-container02 {
    width: 100%;
  }

  .lojas-perfis-add-edit-main-perfil {
    left: 0px;
    width: 100%;
    height: 100%;
    max-width: auto;
    min-width: 320px;
  }
}

@media (max-width: 479px) {
  .lojas-perfis-add-edit-container01 {
    width: 98%;
  }

  .lojas-perfis-add-edit-main-perfil {
    width: 98%;
    min-width: 320px;
  }
}
</style>
